import React, { Dispatch, Fragment, PureComponent, ReactNode, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { AnimatePresence } from 'framer-motion';
import pushVisit, {
    PrintConfig,
    Response,
    Translate,
    COMMUNICATION,
    ALREADY_SAVED,
    LATEST_DRAFT_NOT_APPLIED,
} from '../../../../api/pushVisit';
import { GO_TO_APPOINTMENTS, GO_TO_PRESCRIPTION_PAD_V2 } from '../../../../routes/paths';
import {
    createPrescriptionTemplate,
    CreatePrescriptionTemplateAction,
    finishPrescription,
    FinishPrescriptionAction,
    sanitizeFinalPrescription,
    showDialog,
    updatePatient,
} from '../../../../store/actions/prescriptionPad';
import {
    deletePatientByLocalId,
    getPatientByLocalId,
    getVisitById,
    updatePrescriptionUrlAndVisitNameInVisit,
    updatePtInVisit,
    upsertPatient,
    updatePtInPx,
    getTemplates,
    getPrintConfig,
    getItemFromMisc,
    MISC_KEYS,
    markPrescriptionAsPushFailedStatus,
    getTemplateV2,
    getSingleDoctor,
    getMySingleDoctorId,
    isSingleDoctorAccess,
} from '../../../../store/idbHandler';
import { GlobalState, GlobalStateV1 } from '../../../../store/reducers';
import {
    getInventory,
    getPrescription,
    getPrintConfigs,
    getTranslate,
    isPhDialogVisible,
} from '../../../../store/selectors/prescriptionPad';
import { Attachment, Prescription } from '../../../../store/types/prescription';
import CreateTemplateDialog from './CreateTemplateDialog';
import { generateVisitName, getAgeInYears } from '../../../../store/utils';
import { vc } from '../../../../pages/videoRef';
import SendCommunicationDialog from '../../../common/SendCommunication';
import {
    checkboxEnabledMonetization,
    getPxPrintUrl,
    getRXMonetisationType,
    HxngMonetisation,
    isIPad,
    isOnboardedForLab,
    isOnboardedForPharma,
    isRXMonetisationT1,
    isRXMonetisationT2,
    MONETISATION_TYPE,
} from '../../../../pages/utils';
import { track } from '../../../../tracking';
import sendReviewLink from '../../../../api/sendReviewLink';
import { WithKeyboardPressHandling } from '../../../common/WithKeyboardPressHandling';
import { EditPrescriptionBt } from '../previewScreen/PreviewPanel';
import PrescriptionPDF from '../PrescriptionPDF';
import RequestVitals from './RequestsVitals';
import {
    getGenieSetting,
    getPxElementConfig,
    getSectionNameConfig,
} from '../../../../store/selectors/session';
import { OrderMedicineDialog } from './OrderMedicine';
import { sanitizeFinalPrescriptionFunction } from '../../../../store/appReduxMiddleware';
import { store } from '../../../../App';
import { captureError } from '../../../../pages/captureError';
import { BookLabTestsDialog } from './BookLabTests';
import { TemplateV2 } from '../../../../Templar/RenderPdfPrescription';
import {
    GeniePadElementsSettingItem,
    GenieSettings,
    MessageConfigType,
    SREV2,
} from '../../../../api/pushGenie';
import { dispatch as ekaEventDispath } from '../../../../bridge/events/dispatch';
import { Button, Checkbox, Modal, RadioChangeEvent, notification } from 'antd';
import RxWhatsApp from './RxWhatsApp';
import triggerVisitMessage from '../../../../api/triggerVisitMessage';
import { MESSAGE_CONFIG_ID } from '../../../../constants';
import AttachmentPopUp from '../workspace/AttachmentModal';
import sendAttachments, { Attachment as SendAttachment } from '../../../../api/sendAttachments';
import setHXNGConsent from '../../../../api/setHXNGConsent';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { MonetizeRxButton } from './MonetizeRxButton';
import { Response as PharmaResponse } from '../../../../api/fetchMedicinesByPrescriptionId';
import createLabTestCart, { Response as LabResponse } from '../../../../api/createLabTestCart';
import { showOverrideVisitDialog } from '../../../common/overrideVisitDialog';
import setPartnerConsent, { PARTNER } from '../../../../api/setPartnerConsent';
import TextArea, { TextAreaRef } from 'antd/lib/input/TextArea';
import { ONEMG } from './OrderMedicineUtils';
import { AntTooltip } from '../../../common/AntTooltip';
import { Inventory } from '../workspace/PrescribeAutoSuggestV2';
import { HXNGInfoModal } from './HXNGInfoModal';
import { SectionNameConfig } from '../../../../store/db';
import { BookLabTestNewButton } from './HXNGButtons';
import { calculateExtraCharges } from './BookLabTestsUtils';
import { saveConcierge } from './ConciergeButton';
import { ALL_KINDS } from '../../../../utils/enums';
import { getMyDbId, getMyIdWithBackwardCompatibility } from '../../../../api/mactiveid';
import { getAccessControl, showAccessDeniedError } from '../../../../store/AccessControl';
import { getAclViewClassName } from '../../../../restrictions/utils';
import { rxWithoutLatestDraft } from '../../../common/rxWithoutLatestDraft';
import CreateLocalPrintPdf from '../CreateLocalPrintPdf';
import { BizSettings } from '../../../../api/fetchMyGenie';
import { getDefiniteMActiveId } from '../../../../store/localstorage';

const GoToQueueButton = ({
    prescription,
    isSendRxMessage,
    initiatingRxMonetization,
    twinHealth,
    twinHealthNotes,
    isRXMT,
    isConciergeSaved,
    conciergeDiscount,
    totalLabTests,
}: {
    prescription: Prescription;
    isSendRxMessage?: boolean;
    twinHealth?: boolean;
    initiatingRxMonetization?: () => Promise<void>;
    twinHealthNotes?: string;
    isRXMT: boolean;
    isConciergeSaved?: boolean;
    conciergeDiscount?: string;
    totalLabTests?: number;
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [blockMessage, setBlockMessage] = useState(false);
    const history = useHistory();

    const rxMonetisationType = getRXMonetisationType() || '';
    const sendRxMonetizationMessage = checkboxEnabledMonetization.has(rxMonetisationType);
    const { id, patient } = prescription;

    const goToQueue = () => {
        history.replace(GO_TO_APPOINTMENTS(prescription.clinic._id, undefined, true));

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (vc && !vc.closed) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            vc.close();
        }
        initiatingRxMonetization && initiatingRxMonetization();

        if (twinHealth) {
            const data = {
                patientid: prescription.patient.id || prescription.patient.localId,
                pxid: prescription.id,
                visitid: prescription.visitId,
                partner: PARTNER.twinhealth,
                notes: twinHealthNotes,
            };

            track('PARTNER_CONSENT', data);
            setPartnerConsent(data)
                .then(() => {
                    notification.success({
                        message: 'Consent sent successfully!',
                        duration: 5,
                        placement: 'topRight',
                    });
                })
                .catch((e) => {
                    console.error(e);
                    captureError(e);
                    track('ERROR', { on: 'setPartnerConsent', what: e.message });
                    notification.error({
                        message: 'Failed to send consent!',
                        duration: 5,
                        placement: 'topRight',
                    });
                });
        }

        if (isConciergeSaved) {
            saveConcierge(id, patient.id || patient.localId, conciergeDiscount, totalLabTests);
        }
    };

    const openConfirmationModal = () => {
        const t = Modal.confirm({
            title: 'Unable to send Rx Message to Patient.',
            okText: 'Retry',
            cancelText: 'End Visit Anyways',
            okButtonProps: { className: 'primary-btn font-lato' },
            cancelButtonProps: { className: 'neutral-btn font-lato' },
            visible: true,
            keyboard: true,
            closable: true,
            onOk: async () => {
                onSendRxAndEndVisit();
            },
            onCancel: (args) => {
                if (args?.triggerCancel) {
                    track('RETRY_WHATSAPP_MESSAGE_CANCEL_DIALOG', { padPxId: prescription?.id });
                    return;
                }
                goToQueue();
                t.destroy();
                return;
            },
        });
    };

    const onSendRxAndEndVisit = async () => {
        setIsLoading(true);
        const monetisationType = isRXMT && sendRxMonetizationMessage ? rxMonetisationType : '';
        try {
            await triggerVisitMessage(prescription, monetisationType as MONETISATION_TYPE);
            goToQueue();
        } catch (error) {
            openConfirmationModal();
            track('ERROR', {
                on: 'triggerPushVisit',
                what: 'error failed to send rx visit message',
                error: (error as Error).message,
            });
        }

        setIsLoading(false);

        if (isConciergeSaved) {
            saveConcierge(id, patient.id || patient.localId, conciergeDiscount, totalLabTests);
        }
    };

    if (isSendRxMessage) {
        return (
            <div className="flex flex-col items-end space-y-2">
                <span
                    onClick={() => setBlockMessage(!blockMessage)}
                    className="text-12 space-x-8 cursor-pointer font-700"
                >
                    <span>Send Rx</span>
                    <Checkbox checked={!blockMessage}></Checkbox>
                </span>
                <button
                    disabled={isLoading}
                    onClick={
                        blockMessage
                            ? sendRxMonetizationMessage
                                ? onSendRxAndEndVisit
                                : goToQueue
                            : onSendRxAndEndVisit
                    }
                    className="space-x-4 inline-flex items-center focus:outline-none font-600 text-white rounded-4 hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled disabled:cursor-not-allowed bg-actionPrimary px-12 py-8 btn--small"
                >
                    {isLoading && (
                        <svg
                            className="w-16 h-16 fill-white animate-spin"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                        </svg>
                    )}

                    {blockMessage ? (
                        <span className="w-full text-center">End Visit</span>
                    ) : (
                        <span className="w-full text-center">Send Rx & End Visit</span>
                    )}
                </button>
            </div>
        );
    }

    return (
        <div>
            <button
                onClick={sendRxMonetizationMessage ? onSendRxAndEndVisit : goToQueue}
                className="inline-flex items-center focus:outline-none font-600 text-white rounded-4 hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled disabled:cursor-not-allowed bg-actionPrimary px-12 py-8 btn--small"
            >
                <span className="w-full text-center">End Visit</span>
            </button>
        </div>
    );
};

const OrderMedicineBt: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="flex items-center space-x-4 secondary-btn px-12 py-8 btn--small"
        >
            <svg
                className="w-18 h-16 fill-darwin-primary-500"
                viewBox="0 0 19 15"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M16.5312 5.46875C14.5625 3.53125 11.4062 3.53125 9.4375 5.46875C7.5 7.4375 7.5 10.5938 9.4375 12.5625C11.4062 14.5 14.5625 14.5 16.5312 12.5625C18.4688 10.5938 18.4688 7.4375 16.5312 5.46875ZM10.0312 7.125L14.875 11.9688C11.7188 13.9688 8.03125 10.2812 10.0312 7.125ZM15.9375 10.9062L11.0938 6.0625C14.25 4.0625 17.9688 7.75 15.9375 10.9062ZM3.5 0C1.5625 0 0 1.59375 0 3.5V10.4688C0 12.4062 1.5625 13.9375 3.5 13.9375C5.40625 13.9375 7 12.375 7 10.4688V3.5C7 1.59375 5.40625 0 3.5 0ZM5.5 7H1.5V3.5C1.5 0.84375 5.5 0.84375 5.5 3.5V7Z" />
            </svg>

            <span className="w-full text-center">Order Medicines</span>
        </button>
    );
};

const BookLabTestBt: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="flex items-center space-x-5 secondary-btn px-12 py-8 btn--small"
        >
            <svg
                className="w-18 h-13 fill-darwin-primary-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
            >
                <path d="M504.1 183l-176-176C324.3 2.344 318.1 0 312 0s-12.28 2.344-16.97 7.031c-9.375 9.375-9.375 24.56 0 33.94l15.16 15.16l-277.3 276.5c-38.75 38.75-45.13 102-9.375 143.5C44.08 500 72.76 512 101.5 512h.4473c26.38 0 52.75-9.1 72.88-30.12l281-280.1l15.19 15.19C475.7 221.7 481.8 224 488 224s12.28-2.344 16.97-7.031C514.3 207.6 514.3 192.4 504.1 183zM333.4 256H177.7l166.3-165.9l77.82 77.73L333.4 256z"></path>
            </svg>

            <span className="w-full text-center">Book Lab Tests</span>
        </button>
    );
};

const LS_KEY_FEATURE_HXNG_BANNER = 'feature/hxng-banner';
const LS_KEY_FEATURE_HXNG_INFO_MODAL = 'feature/hxng-info-modal';

export type PushStatus = 'loading' | 'success' | 'error' | 'offline';

const PushData = ({
    prescription,
    printConfig,
    onPrint,
    onDownload,
    translate,
    pushStatus,
    setPushState,
    delayed_rx_message,
    setForce,
    medElements,
    sectionNameConfig,
    padElementsConfig,
    isFetchingCartDetails,
    pharmaResponse,
    labResponse,
    pincode,
    consentGiven,
    setConsentGiven,
    setIgnoreDraft,
    isForce,
    isIgnoreDraft,
}: {
    prescription: Prescription;
    printConfig: PrintConfig;
    onPrint: () => void;
    onDownload: () => void;
    setPushState: (status: PushStatus) => void;
    pushStatus?: PushStatus;
    translate: Translate;
    delayed_rx_message?: boolean;
    setForce: (force: boolean) => void;
    medElements?: GeniePadElementsSettingItem[];
    padElementsConfig?: GeniePadElementsSettingItem[];
    sectionNameConfig?: SectionNameConfig;
    isFetchingCartDetails?: boolean;
    pharmaResponse?: PharmaResponse;
    labResponse?: LabResponse;
    pincode: string;
    consentGiven: boolean;
    setConsentGiven: (consentGiven: boolean) => void;
    setIgnoreDraft: (isIgnoreDraft: boolean) => void;
    isForce: boolean;
    isIgnoreDraft: boolean;
}) => {
    const [wpString, setWpString] = useState<string>('');
    const [canPay, setCanPay] = useState(false);
    const [isPaymentRequested, setPaymentRequestredSuccessfully] = useState('');
    const [communication, setCommunication] = useState<COMMUNICATION | undefined>(undefined);
    const [reviewSendStatus, setReviewSendStatus] = useState<'' | 'loading' | 'error' | 'success'>(
        '',
    );
    const [isAttachmentDialogVisible, setIsAttachmentDialogVisible] = useState(false);
    const [attachmentState, setAttachmentState] = useState<
        'no-attachment' | 'sending' | 'sent' | 'failed'
    >('no-attachment');
    const [isOrderMedicineDialogVisible, setIsOrderMedicineDialogVisible] = useState(false);
    const [isBookLabTestDialogVisible, setIsBookLabTestDialogVisible] = useState(false);
    const [hideHXNGBanner, setHideHXNGBanner] = useState(
        localStorage.getItem(LS_KEY_FEATURE_HXNG_BANNER),
    );
    const [isHXNGInfoModalVisible, setIsHXNGInfoModalVisible] = useState(false);
    const inventory = useSelector(getInventory);
    const hideNewHxngFlow = useSelector(
        (state: GlobalState) => getGenieSetting(state, 'hideNewHxngFlow') as boolean,
    );
    const isBusinessDoctor = !!getSingleDoctor()?.profile?.professional?.businessId;

    const history = useHistory();
    const goToQueue = () => {
        history.replace(GO_TO_APPOINTMENTS(prescription.clinic._id, undefined, true));

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (vc && !vc.closed) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            vc.close();
        }
    };

    const showPaymentDialog = () => {
        track('showPaymentDialog');
        const { patient, clinic, visitId, date } = prescription;
        ekaEventDispath({
            type: 'REQUEST_PAYMENT',
            data: {
                aid: visitId,
                uhid: patient.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
                patient: {
                    mobile: patient.profile.personal.phone?.n,
                    uuid: patient.id as string,
                    fln: patient.profile.personal.name,
                    oid: patient.id,
                },
                clinicId: clinic._id,
                source: 'request-payment',
                aptDate: date.toISOString(),
            },
        });
    };

    const showGenerateInvoiceDialog = () => {
        track('showGenerateInvoiceDialog');
        const { patient, clinic, visitId, date, doctor } = prescription;
        ekaEventDispath({
            type: 'BILLING_POPUP',
            data: {
                docid: doctor._id,
                aid: visitId,
                uhid: patient.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
                patient: {
                    mobile: patient.profile.personal.phone?.n,
                    uuid: patient.id as string,
                    fln: patient.profile.personal.name,
                    oid: patient.id,
                },
                clinicId: clinic._id,
                source: 'prescription',
                aptDate: date.toISOString(),
            },
        });
    };

    const onSetCommunication = (communication?: COMMUNICATION) => {
        setCommunication(communication);
    };

    const onSetAttachmentState = (
        attachmentState: 'no-attachment' | 'sending' | 'sent' | 'failed',
    ) => {
        setAttachmentState(attachmentState);
    };

    const onMount = (force: boolean = false, ignoredraft: boolean = false) => {
        if (prescription.attachment) {
            onSetAttachmentState('sending');
        }
        const rxMonetisationType = getRXMonetisationType() || '';
        const send_rx_message =
            !delayed_rx_message && !checkboxEnabledMonetization.has(rxMonetisationType);
        setPushState('loading');
        triggerPushVisit(
            prescription,
            printConfig,
            translate,
            setPushState,
            setWpString,
            setCanPay,
            undefined,
            onSetCommunication,
            send_rx_message,
            prescription.attachment ? onSetAttachmentState : undefined,
            force,
            undefined,
            medElements,
            padElementsConfig,
            sectionNameConfig,
            setConsentGiven,
            ignoredraft,
            prescription.meta?.draftId,
        ).catch((e) => {
            if (e.message === ALREADY_SAVED) {
                showOverrideVisitDialog(
                    () => {
                        onMount(true, ignoredraft);
                        setForce(true);
                    },
                    () => {
                        goToQueue();
                        setForce(false);
                    },
                );
            } else if (e.message === LATEST_DRAFT_NOT_APPLIED) {
                rxWithoutLatestDraft(
                    () => {
                        window.location.href = GO_TO_PRESCRIPTION_PAD_V2(prescription.id, 'edit');
                    },
                    () => {
                        onMount(isForce, true);
                        setIgnoreDraft(true);
                    },
                );
            }
        });
    };

    useEffect(() => onMount(isForce, isIgnoreDraft), []);

    const onWhatsAppSendClick = () => {
        track('onWhatsAppSendClick');
        try {
            const { phone } = prescription.patient.profile.personal;
            const { c, n } = phone || {};
            const number = (c?.replaceAll('+', '') || '') + n;
            wpString &&
                n &&
                window.open(
                    `https://api.whatsapp.com/send?phone=${number}&text=${wpString}`,
                    '_blank',
                );
        } catch (e) {
            console.error(e);
        }
    };

    const phoneNumber =
        ((prescription.patient.profile.personal.phone?.n
            ? prescription.patient.profile.personal.phone?.c
            : '') || '') +
        ' ' +
        (prescription.patient.profile.personal.phone?.n || '').trim();

    const dispatch = useDispatch();

    const onPhoneChange = () => {
        dispatch(showDialog('ph'));
        return;
    };

    const onSendReviewLink = async () => {
        setReviewSendStatus('loading');
        const { visitId } = prescription;
        const res = await sendReviewLink(visitId);

        track('SEND_REVIEW_LINK', { success: `${res.success}` });

        setReviewSendStatus(res.success ? 'success' : 'error');
        if (!res.success) {
            alert(res.error.message);
        }
    };

    const onSendAttachment = async (attachment: Attachment) => {
        setAttachmentState('sending');

        const personal = prescription?.patient?.profile.personal;

        if (!attachment?.title) {
            notification.error({
                message: 'Title is required',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }

        if (!prescription?.patient?.id || !personal) {
            notification.error({
                message: 'Patient Not Found',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }

        try {
            const attachments: SendAttachment = {
                post: {
                    type: 'ATTACH',
                    meta: {
                        display: {
                            title: attachment?.title || '',
                            description: attachment?.description,
                            link: attachment?.link,
                            file_type: attachment?.file_type,
                        },
                    },
                },
                share: {
                    type: 'PRIVATE',
                    audience: [
                        {
                            id: prescription?.patient?.id,
                            profile: {
                                personal: {
                                    name: personal?.name,
                                    phone: personal.phone || { c: '', n: '' },
                                    age: personal?.age,
                                    gender: personal?.gender,
                                    mobile: (personal.phone?.c || '') + (personal.phone?.n || ''),
                                    fn: personal?.name,
                                },
                            },
                        },
                    ],
                },
            };

            const res = await sendAttachments({
                attachments: attachments,
                blockTemplateMaking: attachment.templateId ? true : false,
            });

            if (res.status === 'success') {
                notification.success({
                    message: 'Attachments sent successfully',
                    duration: 5,
                    placement: 'topRight',
                });
                setAttachmentState('sent');
                track(
                    attachment?.templateId
                        ? 'TEMPLATE_SEND_SUCCESSFUL'
                        : 'ATTACHMENT_SEND_SUCCESSFUL',
                );
            } else {
                notification.error({
                    message: 'Failed to send Attachments',
                    duration: 5,
                    placement: 'topRight',
                });
                setAttachmentState('failed');
                track(
                    attachment?.templateId
                        ? 'TEMPLATE_SEND_UNSUCCESSFUL'
                        : 'ATTACHMENT_SEND_UNSUCCESSFUL',
                );
            }
        } catch (error) {
            notification.error({
                message: 'Failed to send Attachments',
                duration: 5,
                placement: 'topRight',
            });
            setAttachmentState('failed');
            track(
                attachment?.templateId
                    ? 'TEMPLATE_SEND_UNSUCCESSFUL'
                    : 'ATTACHMENT_SEND_UNSUCCESSFUL',
            );
        }
    };

    const toggleOrderMedicineDialogVisible = (bypassHXNGInfoModal?: boolean) => {
        if (pushStatus !== 'success') return;
        const hxngInfoModalAlreadyOpened =
            localStorage.getItem(LS_KEY_FEATURE_HXNG_INFO_MODAL) === 'true';
        if (hxngInfoModalAlreadyOpened || bypassHXNGInfoModal) {
            setIsOrderMedicineDialogVisible(!isOrderMedicineDialogVisible);
        } else {
            setIsHXNGInfoModalVisible(true);
            localStorage.setItem(LS_KEY_FEATURE_HXNG_INFO_MODAL, 'true');
        }
        const cartMxLength = String(pharmaResponse?.cart_mx?.length);
        const unavailableMxLength = String(pharmaResponse?.unavailable_mx?.length);
        track('ORDER_MEDICINE', {
            pxId: prescription?.id,
            from: 'finish page',
            totalMedications: String(medications?.length),
            cartMxLength,
            unavailableMxLength,
        });
    };

    const toggleBookLabTestDialogVisible = (bypassHXNGInfoModal?: boolean) => {
        if (pushStatus !== 'success') return;
        const hxngInfoModalAlreadyOpened =
            localStorage.getItem(LS_KEY_FEATURE_HXNG_INFO_MODAL) === 'true';
        if (hxngInfoModalAlreadyOpened || bypassHXNGInfoModal) {
            setIsBookLabTestDialogVisible(!isBookLabTestDialogVisible);
        } else {
            setIsHXNGInfoModalVisible(true);
            localStorage.setItem(LS_KEY_FEATURE_HXNG_INFO_MODAL, 'true');
        }
        const cartLxLength = String(labResponse?.data?.[0]?.sku?.length);
        const unavailableLxLength = String(labResponse?.data?.[0]?.unavailableLabTests?.length);
        const totalOptions = String(labResponse?.data?.length);
        const vendorId = labResponse?.data?.[0]?.vendor_id;
        track('BOOK_LAB_TEST', {
            pxId: prescription?.id,
            from: 'finish page',
            totalLabTests: String(labTests?.length),
            cartLxLength,
            unavailableLxLength,
            totalOptions,
            vendorId,
        });
    };

    const onClose = () => {
        if (pushStatus === 'loading') return;
        localStorage.setItem(LS_KEY_FEATURE_HXNG_BANNER, 'true');
        setHideHXNGBanner('true');
        track('CROSS', {
            element: 'feature/hxng-banner strip',
        });
    };

    const toggleIsHXNGInfoModalVisible = () => {
        setIsHXNGInfoModalVisible(!isHXNGInfoModalVisible);
        track('HXNG_INFO_MODAL', { value: String(!isHXNGInfoModalVisible) });
    };

    const ageObj = prescription.patient.profile.personal.age || {};
    const age = getAgeInYears(ageObj) || 18;
    const { medications = [], labTests = [] } = prescription;
    const isVendorIsOneMg = pharmaResponse?.vendor === ONEMG;
    const cartMxLength = Number(pharmaResponse?.cart_mx?.length);
    const unavailableMxLength = Number(pharmaResponse?.unavailable_mx?.length);
    const pharmaCartAmount = Number(pharmaResponse?.totalAmount);
    const cartLxLength = Number(labResponse?.data?.[0]?.sku?.length);
    const unavailableLxLength = Number(labResponse?.data?.[0]?.unavailableLabTests?.length);
    const totalOptions = Number(labResponse?.data?.length);
    const extraCharges = labResponse?.data?.[0] ? calculateExtraCharges(labResponse?.data?.[0]) : 0;
    const labCartAmount = Number(labResponse?.data?.[0]?.finalprice) + extraCharges;
    const patientName = prescription.patient.profile.personal.name;

    const canCreateReceipt = getAccessControl().isAccessAvailable(
        SREV2.CAN_CREATE_RECEIPT_WITH_APT,
    );

    return (
        <Fragment>
            <div className="flex flex-col justify-center pb-20 space-y-20 select-none">
                {!consentGiven &&
                    !hideNewHxngFlow &&
                    !isBusinessDoctor &&
                    isSingleDoctorAccess() &&
                    !isOnboardedForPharma() &&
                    !isOnboardedForLab() &&
                    JSON.stringify(inventory) === '{}' &&
                    hideHXNGBanner !== 'true' &&
                    labTests.length !== 0 && (
                        <div
                            className={`relative p-16 rounded-8 bg-white space-y-12 ${getAclViewClassName(
                                SREV2.HXNG_ORDERS,
                            )}`}
                            style={{ border: '1px solid #FF6208' }}
                        >
                            <div className="flex items-start space-x-8">
                                <p className="font-700">
                                    Provide delivery for{' '}
                                    <span style={{ color: '#FF6208' }}>Lab Tests.</span> Pincode:{' '}
                                    <span className="text-darwin-accent-bright-blue-800">
                                        {pincode || 'NA'}
                                    </span>
                                </p>
                            </div>
                            <div className="flex gap-8 flex-wrap">
                                {/* <OrderMedicineNewButton
                                    medications={medications}
                                    isFetchingCartDetails={isFetchingCartDetails}
                                    toggleOrderMedicineDialogVisible={
                                        toggleOrderMedicineDialogVisible
                                    }
                                    isVendorIsOneMg={isVendorIsOneMg}
                                    cartMxLength={cartMxLength}
                                    unavailableMxLength={unavailableMxLength}
                                    pushStatus={pushStatus}
                                    amount={pharmaCartAmount}
                                /> */}
                                <BookLabTestNewButton
                                    labTests={labTests}
                                    isFetchingCartDetails={isFetchingCartDetails}
                                    toggleBookLabTestDialogVisible={toggleBookLabTestDialogVisible}
                                    cartLxLength={cartLxLength}
                                    unavailableLxLength={unavailableLxLength}
                                    totalOptions={totalOptions}
                                    pushStatus={pushStatus}
                                    amount={labCartAmount}
                                />
                            </div>
                            <AntTooltip content="Don't show again">
                                <div
                                    className={`absolute -top-4 right-8 cursor-pointer ${
                                        pushStatus === 'loading'
                                            ? 'opacity-70 cursor-not-allowed'
                                            : ''
                                    }`}
                                    onClick={onClose}
                                >
                                    <svg
                                        className="w-20 h-18 fill-darwin-neutral_new-800"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM6.46875 5.46875C6.15625 5.78125 6.15625 6.25 6.46875 6.53125L7.9375 8L6.46875 9.46875C6.15625 9.78125 6.15625 10.25 6.46875 10.5312C6.75 10.8438 7.21875 10.8438 7.5 10.5312L8.96875 9.0625L10.4375 10.5312C10.75 10.8438 11.2188 10.8438 11.5 10.5312C11.8125 10.25 11.8125 9.78125 11.5 9.46875L10.0312 8L11.5 6.53125C11.8125 6.25 11.8125 5.78125 11.5 5.46875C11.2188 5.1875 10.75 5.1875 10.4375 5.46875L8.96875 6.9375L7.5 5.46875C7.21875 5.1875 6.75 5.1875 6.46875 5.46875Z" />
                                    </svg>
                                </div>
                            </AntTooltip>
                        </div>
                    )}
                {consentGiven && labTests.length !== 0 && (
                    <div
                        className="relative p-16 rounded-8 bg-white space-y-12"
                        style={{ border: '1px solid #FF6208' }}
                    >
                        <div className="flex items-start space-x-16">
                            <div className="pt-2">
                                <svg
                                    className="w-36 h-36"
                                    viewBox="0 0 36 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect width="36" height="36" rx="18" fill="#E8F6F0" />
                                    <path
                                        d="M18 30C13.6875 30 9.75 27.75 7.59375 24C5.4375 20.2969 5.4375 15.75 7.59375 12C9.75 8.29688 13.6875 6 18 6C22.2656 6 26.2031 8.29688 28.3594 12C30.5156 15.75 30.5156 20.2969 28.3594 24C26.2031 27.75 22.2656 30 18 30ZM23.2969 15.7969H23.25C23.7188 15.375 23.7188 14.6719 23.25 14.2031C22.8281 13.7812 22.125 13.7812 21.7031 14.2031L16.5 19.4531L14.2969 17.25C13.8281 16.7812 13.125 16.7812 12.7031 17.25C12.2344 17.6719 12.2344 18.375 12.7031 18.7969L15.7031 21.7969C16.125 22.2656 16.8281 22.2656 17.2969 21.7969L23.2969 15.7969Z"
                                        fill="#19A66A"
                                    />
                                </svg>
                            </div>
                            <div className="space-y-4">
                                <p className="text-13 font-700">
                                    {patientName} showed interest in{' '}
                                    <span style={{ color: '#FF6208' }}>Lab Test services.</span>
                                </p>
                                <p className="text-12 text-darwin-neutrals-600 font-700">
                                    Pincode:{' '}
                                    <span className="text-darwin-accent-bright-blue-800">
                                        {pincode || 'NA'}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-8 flex-wrap">
                            {/* <OrderMedicineNewButton
                                medications={medications}
                                isFetchingCartDetails={isFetchingCartDetails}
                                toggleOrderMedicineDialogVisible={toggleOrderMedicineDialogVisible}
                                isVendorIsOneMg={isVendorIsOneMg}
                                cartMxLength={cartMxLength}
                                unavailableMxLength={unavailableMxLength}
                                pushStatus={pushStatus}
                                amount={pharmaCartAmount}
                                bypassHXNGInfoModal
                            /> */}
                            <BookLabTestNewButton
                                labTests={labTests}
                                isFetchingCartDetails={isFetchingCartDetails}
                                toggleBookLabTestDialogVisible={toggleBookLabTestDialogVisible}
                                cartLxLength={cartLxLength}
                                unavailableLxLength={unavailableLxLength}
                                totalOptions={totalOptions}
                                pushStatus={pushStatus}
                                amount={labCartAmount}
                                bypassHXNGInfoModal
                            />
                        </div>
                    </div>
                )}

                {!delayed_rx_message &&
                    prescription.patient.profile.personal.phone?.n &&
                    communication !== COMMUNICATION.NOT_APPLICABLE && (
                        <p className="text-neutral-3">Sending prescription link to the patient:</p>
                    )}
                <div className="space-y-24 text-textColor-grey font-600">
                    <RxWhatsApp
                        pushStatus={pushStatus}
                        onPhoneChange={onPhoneChange}
                        phoneNumber={phoneNumber}
                        communication={communication}
                    />

                    <div>
                        <AttachmentPopUp
                            patientId={prescription?.patient?.id}
                            isVisible={isAttachmentDialogVisible}
                            onVisibleChange={(visible) => {
                                setIsAttachmentDialogVisible(visible);
                            }}
                            onSend={onSendAttachment}
                            templateApplyText={'Send'}
                            templateApplyIcon={
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-14 h-16 fill-actionPrimary-hover"
                                    >
                                        <path d="M133.9 232L65.8 95.9 383.4 232H133.9zm0 48H383.4L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z" />
                                    </svg>
                                </span>
                            }
                        />

                        <span
                            onClick={() => {
                                attachmentState === 'sent' || attachmentState === 'sending'
                                    ? notification.info({
                                          message: 'Attachment already sent!',
                                          duration: 5,
                                      })
                                    : setIsAttachmentDialogVisible(true);
                                track('ATTACHMENT_CLIKED');
                            }}
                            role="button"
                            className={`font-600 gap-8 rounded-24 inline-flex items-center justify-center cursor-pointer text-white px-12 py-4 text-14 chip-show mr-16 mt-16 ${
                                attachmentState === 'failed'
                                    ? 'bg-white text-red-primary border border-red-primary'
                                    : 'bg-actionPrimary hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled'
                            } ${getAclViewClassName(SREV2.SEND_ATTACHMENT)}`}
                        >
                            {(attachmentState === 'no-attachment' ||
                                attachmentState === 'sending') && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 12 16"
                                    className="w-14 h-14"
                                    fill="#FFFFFF"
                                >
                                    <path d="M2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0ZM8 0L12 4H8V0ZM5.25 13.25C5.25 13.6875 5.5625 14 6 14C6.40625 14 6.75 13.6875 6.75 13.25V11.25H8.75C9.15625 11.25 9.5 10.9375 9.5 10.5C9.5 10.0938 9.15625 9.75 8.75 9.75H6.75V7.75C6.75 7.34375 6.40625 7 6 7C5.5625 7 5.25 7.34375 5.25 7.75V9.75H3.25C2.8125 9.75 2.5 10.0938 2.5 10.5C2.5 10.9375 2.8125 11.25 3.25 11.25H5.25V13.25Z" />
                                </svg>
                            )}

                            {attachmentState === 'sent' && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 12 16"
                                    className="w-14 h-14"
                                    fill="#FFFFFF"
                                >
                                    <path d="M2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0ZM8 0L12 4H8V0ZM9.53125 8.78125H9.5C9.8125 8.5 9.8125 8.03125 9.5 7.71875C9.21875 7.4375 8.75 7.4375 8.46875 7.71875L4.96875 11.2188L3.5 9.75C3.21875 9.4375 2.75 9.4375 2.46875 9.75C2.15625 10.0312 2.15625 10.5 2.46875 10.7812L4.46875 12.7812C4.75 13.0938 5.21875 13.0938 5.53125 12.7812L9.53125 8.78125Z" />
                                </svg>
                            )}
                            {attachmentState === 'failed' && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 12 16"
                                    className="w-14 h-14 fill-red-primary"
                                >
                                    <path d="M2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0ZM8 0L12 4H8V0ZM6 6C5.5625 6 5.25 6.34375 5.25 6.75V10.25C5.25 10.6875 5.5625 11 6 11C6.40625 11 6.75 10.6875 6.75 10.25V6.75C6.75 6.34375 6.40625 6 6 6ZM7 13C7 12.4688 6.53125 12 6 12C5.4375 12 5 12.4688 5 13C5 13.5625 5.4375 14 6 14C6.53125 14 7 13.5625 7 13Z" />
                                </svg>
                            )}
                            {attachmentState === 'no-attachment' && 'Send attachment'}
                            {attachmentState === 'sending' && 'Sending attachment...'}
                            {attachmentState === 'sent' && 'Attachment sent successfully!'}
                            {attachmentState === 'failed' && 'Failed to sent attachment!'}
                        </span>
                        {pushStatus !== 'loading' && (
                            <div className="flex flex-wrap">
                                <span
                                    onClick={() => {
                                        onPrint(); //uses onPrintLocally
                                        track('PRINT', { from: 'top' });
                                    }}
                                    role="button"
                                    className="font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mr-16 mt-16"
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 28 28"
                                        className="fill-white relative top-2 mr-4 cursor-pointer fill-white relative top-2 mr-4"
                                        preserveAspectRatio="xMidYMid meet"
                                    >
                                        <path d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"></path>
                                    </svg>
                                    <p>Print</p>
                                </span>
                                <span
                                    onClick={onDownload}
                                    role="button"
                                    className="font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mr-16 mt-16"
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 28 28"
                                        className="fill-white relative top-2 mr-4 cursor-pointer fill-white relative top-2 mr-4"
                                        preserveAspectRatio="xMidYMid meet"
                                    >
                                        <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"></path>
                                    </svg>
                                    <p>Download</p>
                                </span>
                                {wpString && (
                                    <span
                                        onClick={onWhatsAppSendClick}
                                        role="button"
                                        className={`font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mt-16 mr-16 ${getAclViewClassName(
                                            SREV2.SEND_RX_VIA_OWN_WA,
                                        )}`}
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 28 28"
                                            className="fill-white relative top-2 mr-4 cursor-pointer fill-white relative top-2 mr-4"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"></path>
                                        </svg>
                                        <p>Send via own Whatsapp</p>
                                    </span>
                                )}
                                {canPay && (
                                    <span
                                        onClick={
                                            isPaymentRequested !== 'success'
                                                ? showPaymentDialog
                                                : undefined
                                        }
                                        role="button"
                                        className={`font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mt-16 mr-16 space-x-8 ${getAclViewClassName(
                                            SREV2.SEND_PAYMENT_LINK,
                                        )}`}
                                    >
                                        <span>
                                            {' '}
                                            {isPaymentRequested === 'success' ? '✓' : '₹'}{' '}
                                        </span>
                                        <p>
                                            {isPaymentRequested === 'success'
                                                ? 'Payment Link Sent'
                                                : 'Send Payment Link'}
                                        </p>
                                    </span>
                                )}
                                <span
                                    onClick={
                                        canCreateReceipt
                                            ? showGenerateInvoiceDialog
                                            : showAccessDeniedError
                                    }
                                    role="button"
                                    className={`font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mt-16 mr-16 space-x-8 ${getAclViewClassName(
                                        SREV2.CAN_CREATE_RECEIPT_WITH_APT,
                                    )}`}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        className="fill-white"
                                        viewBox="0 0 384 512"
                                    >
                                        <path d="M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"></path>
                                    </svg>

                                    <p>Bill Patient</p>
                                </span>
                                <span
                                    onClick={onSendReviewLink}
                                    role="button"
                                    className={`font-600 rounded-24 inline-flex items-center justify-center cursor-pointer bg-actionPrimary text-white hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled px-12 py-4 text-14 chip-show mt-16 mr-16 space-x-8 ${getAclViewClassName(
                                        SREV2.SEND_GOOGLE_REVIEW,
                                    )}`}
                                >
                                    <span>
                                        {reviewSendStatus === 'success' ? (
                                            '✓'
                                        ) : reviewSendStatus === 'loading' ? (
                                            <div className="w-16 h-16 flex items-center justify-center">
                                                <svg
                                                    viewBox="0 0 512 512"
                                                    className="fill-white animate-spin"
                                                    width="20"
                                                    height="20"
                                                >
                                                    <path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
                                                </svg>
                                            </div>
                                        ) : (
                                            <div className="w-16 h-16 flex items-center justify-center">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    data-prefix="fab"
                                                    data-icon="google"
                                                    className="fill-white"
                                                    role="img"
                                                    viewBox="0 0 488 512"
                                                    width="16"
                                                    height="16"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                                                    />
                                                </svg>
                                            </div>
                                        )}{' '}
                                    </span>
                                    <p>
                                        {reviewSendStatus === 'success'
                                            ? 'Google Review Link Sent Successfully'
                                            : 'Send Google Review Link'}
                                    </p>
                                </span>
                                {prescription.patient?.profile?.personal?.gender?.toLowerCase() !==
                                    'other' && (
                                    <RequestVitals
                                        ptId={
                                            prescription.patient.id || prescription.patient.localId
                                        }
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {!consentGiven &&
                    !hideNewHxngFlow &&
                    !isBusinessDoctor &&
                    isSingleDoctorAccess() &&
                    hideHXNGBanner === 'true' &&
                    pushStatus === 'success' && (
                        <div
                            className={`flex gap-8 flex-wrap ${getAclViewClassName(
                                SREV2.HXNG_ORDERS,
                            )}`}
                        >
                            {/* {medications?.length > 0 && (
                                <button
                                    className="flex items-center space-x-8 px-10 py-7 rounded-full border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100"
                                    onClick={() => toggleOrderMedicineDialogVisible()}
                                >
                                    <p className="text-13 font-700 text-darwin-accent-bright-blue-800">
                                        Order Medicines
                                    </p>
                                    <p>
                                        <OneMgSvg width="60" height="20" />
                                    </p>
                                </button>
                            )} */}
                            {labTests?.length > 0 && (
                                <button
                                    className="flex items-center space-x-8 px-10 py-1 rounded-full border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100"
                                    onClick={() => toggleBookLabTestDialogVisible()}
                                >
                                    <p className="text-13 font-700 text-darwin-accent-bright-blue-800">
                                        Book Lab Tests
                                    </p>
                                    <p>
                                        <img
                                            src="/images/labs_vendors.gif"
                                            alt={'v_001'}
                                            className="h-28 min-w-64"
                                        />
                                    </p>
                                </button>
                            )}
                        </div>
                    )}
            </div>
            <AnimatePresence>
                {isOrderMedicineDialogVisible && (
                    <OrderMedicineDialog
                        closeMe={toggleOrderMedicineDialogVisible}
                        formData={prescription.patient.formData || []}
                        pxid={prescription.id}
                        patientId={prescription.patient.id || ''}
                        name={prescription.patient.profile.personal.name}
                        phone={prescription.patient.profile.personal.phone?.n || ''}
                        gender={prescription.patient.profile.personal.gender}
                        age={age}
                        clinicPin={prescription.clinic.address?.pin || ''}
                        showGoToHEDashboardButton
                    />
                )}
                {isBookLabTestDialogVisible && (
                    <BookLabTestsDialog
                        closeMe={toggleBookLabTestDialogVisible}
                        formData={prescription.patient.formData || []}
                        pxid={prescription.id}
                        patientid={prescription.patient.id || ''}
                        name={prescription.patient.profile.personal.name}
                        phone={prescription.patient.profile.personal.phone?.n || ''}
                        gender={prescription.patient.profile.personal.gender}
                        age={age}
                        showGoToHEDashboardButton
                    />
                )}
                <HXNGInfoModal
                    isVisible={isHXNGInfoModalVisible}
                    closeMe={toggleIsHXNGInfoModalVisible}
                />
            </AnimatePresence>
        </Fragment>
    );
};

type Props = {
    dispatch: Dispatch<FinishPrescriptionAction | CreatePrescriptionTemplateAction>;
    prescription?: Prescription;
    printConfigs?: PrintConfig;
    phDialogVisisble: boolean;
    translate: Translate;
    twinHealthEnabled: boolean;
    medElements?: GeniePadElementsSettingItem[];
    padElementsConfig?: GeniePadElementsSettingItem[];
    messageConfig?: MessageConfigType[];
    inventory: Inventory;
    hideNewHxngFlow: boolean;
    sectionNameConfig?: SectionNameConfig;
    isHxngPatientConsent: boolean;
};

type State = {
    isCreateTemplateDialogVisible: boolean;
    isOrderMedicineDialogVisible: boolean;
    isBookLabTestDialogVisible: boolean;
    pushStatus?: PushStatus;
    printUrl?: string;
    isPrinting?: boolean;
    printIframeReady?: boolean;
    isPharmaChecked?: boolean;
    isLabChecked?: boolean;
    isRXMTChecked?: boolean;
    isInitiatingRxMonetization?: boolean;
    isFetchingCartDetails?: boolean;
    monetizeAmount: number;
    cartPdfUrl?: string;
    force: boolean;
    ignoredraft: boolean;
    twinHealth?: boolean;
    twinHealthNotes?: string;
    twinhealthModal?: boolean;
    pharmaResponse?: PharmaResponse;
    labResponse?: LabResponse;
    consentGiven: boolean;
    hideShowedInterestStrip: boolean;
    isConciergeChecked?: boolean;
    conciergeDiscount?: string;
    isLocalPdfView?: boolean;
    localPdfPrintEnabled?: boolean;
    isSettingsLoaded?: boolean;
};

const DUMMY_PRINT_PDF_IFRAME = 'DUMMY_PRINT_PDF_IFRAME';
const HXNG_SHOWED_INTEREST_STRIP_SHOWN = 'hxngShowedInterestStripShown';

class FinishedPanel extends PureComponent<Props, State> {
    state: State = {
        isCreateTemplateDialogVisible: false,
        isOrderMedicineDialogVisible: false,
        isBookLabTestDialogVisible: false,
        monetizeAmount: 0,
        force: false,
        ignoredraft: false,
        isFetchingCartDetails: true,
        hideShowedInterestStrip: Boolean(localStorage.getItem(HXNG_SHOWED_INTEREST_STRIP_SHOWN)),
        consentGiven: false,
        // isConciergeChecked: true,
        conciergeDiscount: 'discount',
        isLocalPdfView: false,
        localPdfPrintEnabled: false,
        isSettingsLoaded: false,
    };

    setForce = (force: boolean) => {
        this.setState({
            force,
        });
    };

    setIgnoreDraft = (ignoredraft: boolean) => {
        this.setState({
            ignoredraft,
        });
    };

    unsetPrint = () => {
        this.setState({
            isPrinting: false,
        });
    };

    componentDidMount() {
        window.onafterprint = this.unsetPrint;
        this.props.dispatch(finishPrescription(this.props.prescription));

        this.setState({
            isPharmaChecked: localStorage.getItem('isPharmaChecked') === 'false' ? false : true,
            isLabChecked: localStorage.getItem('isLabChecked') === 'false' ? false : true,
            isRXMTChecked: true,
        });
        const fetchBizSettings = async () => {
            try {
                const bizSettings = await getItemFromMisc<BizSettings>(
                    getDefiniteMActiveId() || '',
                    MISC_KEYS.bizSettings,
                );
                this.setState({
                    localPdfPrintEnabled: !bizSettings.localPrintDisabled,
                    isSettingsLoaded: true,
                });
            } catch (error) {
                console.error('Error fetching settings:', error);
                this.setState({
                    isSettingsLoaded: true, // Set to true to avoid infinite loading
                });
            }
        };

        fetchBizSettings();
    }

    componentWillUnmount() {
        window.onafterprint = () => {
            return;
        };
    }

    onSaveAsTemplate = (name: string, id?: string) => {
        const { dispatch } = this.props;
        dispatch(createPrescriptionTemplate('PX', name, id));
        this.hideCreateTemplateDialog();
    };

    showCreateTemplateDialog = (): void => {
        this.setState({
            isCreateTemplateDialogVisible: true,
        });
    };

    hideCreateTemplateDialog = (): void => {
        this.setState({
            isCreateTemplateDialogVisible: false,
        });
    };

    setPrintUrl = (printUrl: string): void => {
        this.setState({
            printUrl,
        });
    };

    enablePrint = (): void => {
        this.setState(
            {
                printIframeReady: true,
            },
            () => {
                if (new URLSearchParams(location.search).get('print') === 'true') {
                    this.onPrint();
                }
            },
        );
    };

    newTabPrint = async () => {
        const { openPrintPdfInNewTab } = await getItemFromMisc<GenieSettings>(
            getMyIdWithBackwardCompatibility() || '',
            'settings',
        );
        if (openPrintPdfInNewTab) return true;
        return false;
    };

    onPrint = async () => {
        const { printUrl } = this.state;
        const { openPrintPdfInNewTab } = await getItemFromMisc<GenieSettings>(
            getMyIdWithBackwardCompatibility() || '',
            'settings',
        );

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (printUrl && (isIPad() || window.userAgent?.isTablet)) {
            window.open(printUrl);
            return;
        }

        if (openPrintPdfInNewTab) {
            window.open(printUrl);
            return;
        }

        if (printUrl) {
            const p = document.getElementById(DUMMY_PRINT_PDF_IFRAME) as HTMLIFrameElement;
            if (p && p.contentWindow) {
                p?.contentWindow?.print();
            } else {
                alert('PDF is not yet ready for printing');
                window.open(printUrl);
            }

            return;
        }

        alert('can not find printurl');
        track('ERROR', {
            on: 'onPrint',
            what: 'print url not found',
        });

        window.open(getPxPrintUrl(this.props.prescription?.id || ''));
    };

    setPushStatus = (pushStatus: PushStatus) => {
        this.setState({
            pushStatus,
        });
        if (pushStatus === 'loading') {
            this.fetchCartDetails();
        }
    };

    onDownload = () => {
        track('onDownload');
        this.onPrint();
    };

    showOrderMedicineDialogVisible = (): void => {
        this.setState({
            isOrderMedicineDialogVisible: true,
        });
        track('ORDER_MEDICINE', { pxId: this.props.prescription?.id });
    };

    hideOrderMedicineDialogVisible = (): void => {
        this.setState({
            isOrderMedicineDialogVisible: false,
        });
    };

    showBookLabTestDialogVisible = (): void => {
        this.setState({
            isBookLabTestDialogVisible: true,
        });
        track('BOOK_LAB_TEST', { pxId: this.props.prescription?.id });
    };

    hideBookLabTestDialogVisible = (): void => {
        this.setState({
            isBookLabTestDialogVisible: false,
        });
    };

    fetchCartDetails = async (): Promise<void> => {
        const { prescription, inventory, hideNewHxngFlow, isHxngPatientConsent } = this.props;
        const isBusinessDoctor = !!getSingleDoctor()?.profile?.professional?.businessId;
        const isNoMonetisationEnabled = !isRXMonetisationT1() && !isRXMonetisationT2();
        const isHXNGDoctor = isOnboardedForPharma() || isOnboardedForLab();
        const hideHXNGBanner = localStorage.getItem(LS_KEY_FEATURE_HXNG_BANNER);
        if (
            !prescription ||
            (((isHXNGDoctor && isNoMonetisationEnabled) ||
                (hideHXNGBanner === 'true' && isNoMonetisationEnabled) ||
                (JSON.stringify(inventory) !== '{}' && isNoMonetisationEnabled) ||
                hideNewHxngFlow ||
                isBusinessDoctor ||
                !isSingleDoctorAccess()) &&
                !isHxngPatientConsent)
        ) {
            this.setState({
                isFetchingCartDetails: false,
            });
            return;
        }
        const { doctor, patient, medications = [], labTests = [] } = prescription;
        let pharmaResponse;
        let labResponse;
        const clinicPin = prescription.clinic.address?.pin || '';
        const pincode = (patient?.formData?.find((i) => i.key === 'pincode')?.value ||
            clinicPin ||
            '') as string;
        const docId = getMySingleDoctorId() || '';

        try {
            // if (medications?.length) {
            //     pharmaResponse = await fetchMedicinesByPrescriptionId(docId, {
            //         eka_mx: medications as EkaMxEntity[],
            //         pincode: pincode,
            //         docid: doctor._id,
            //         patientid: patient.id || '',
            //         discount: 20,
            //         generate_pdf: true,
            //     });
            // }
            if (labTests?.length) {
                labResponse = await createLabTestCart(docId, {
                    eka_lab: labTests,
                    docid: doctor._id,
                    patientid: patient.id || '',
                    discount: 0,
                });
            }
            let monetizeAmount = 0;
            // if (pharmaResponse?.success) {
            //     const { absoluteDiscount } = pharmaResponse;
            //     monetizeAmount += absoluteDiscount;
            // }
            if (labResponse?.success) {
                const { data } = labResponse;
                monetizeAmount += data[0]?.mrp * 0.2;
            }
            this.setState({
                monetizeAmount: Math.ceil(monetizeAmount) || 0,
                // cartPdfUrl: pharmaResponse?.cart_pdf_url,
                pharmaResponse,
                labResponse,
            });
        } catch (err) {
            captureError(err as Error);
            track('ERROR', {
                on: 'fetchMonetizeAmount',
                error: (err as Error).message,
            });
        } finally {
            this.setState({
                isFetchingCartDetails: false,
            });
        }
    };

    initiatingRxMonetization = async (): Promise<void> => {
        const { prescription } = this.props;
        const { isPharmaChecked, isLabChecked, cartPdfUrl } = this.state;

        if (!prescription) return;

        const {
            id: pxid = '',
            patient: { id: patientid = '' },
        } = prescription;

        const sell =
            isPharmaChecked && isLabChecked
                ? 'both'
                : isPharmaChecked
                ? 'pharma'
                : isLabChecked
                ? 'lab'
                : null;

        if (!sell) return;

        this.setState({
            isInitiatingRxMonetization: true,
        });

        try {
            await setHXNGConsent({ pxid, patientid, sell, cartPdfUrl });
            const today = new Date().toISOString().slice(0, 10);
            localStorage.setItem('rxMonetizationInfoShownDate', today);
            localStorage.setItem('isPharmaChecked', String(isPharmaChecked));
            localStorage.setItem('isLabChecked', String(isLabChecked));
            notification.success({
                message: `Rx Monetization Initiated!`,
                duration: 5,
                placement: 'topRight',
            });
            track('INITIATE_RX_MONETIZATION', {
                pxid,
                sell,
                type: getRXMonetisationType() || '-',
            });
        } catch (err) {
            captureError(err as Error);
            track('ERROR', {
                on: 'setHXNGConsent',
                error: (err as Error).message,
            });
            notification.error({
                message: 'Error in Initiating Rx Monetization!',
                duration: 5,
            });
        } finally {
            this.setState({
                isInitiatingRxMonetization: false,
            });
        }
    };

    rxMonetizationCheckboxToggler = (e: CheckboxChangeEvent, key: string) => {
        if (key === 'pharma') {
            this.setState({
                isPharmaChecked: e.target.checked,
            });
        } else if (key === 'lab') {
            this.setState({
                isLabChecked: e.target.checked,
            });
        } else if (key === 'rxmt') {
            this.setState({
                isRXMTChecked: e.target.checked,
            });
        }
    };

    onTwinHealthChange = (e: CheckboxChangeEvent) => {
        this.setState({
            twinHealth: e.target.checked,
            twinhealthModal: e.target.checked,
        });
        e.preventDefault();
        e.stopPropagation();
    };
    toggleTwinhealth = () => {
        this.setState({
            twinHealth: !this.state.twinHealth,
        });
    };

    twinHealthNotes = () => {
        this.setState({
            twinhealthModal: true,
        });
    };

    onOkTwinHealthNotes = () => {
        const notes = this.notesRef?.resizableTextArea?.props.value?.toString().trim() || '';
        this.setState({
            twinhealthModal: false,
            twinHealthNotes: notes,
            twinHealth: notes.length > 0 || this.state.twinHealth,
        });
    };

    onCancelTwinHealthNotes = () => {
        this.setState({
            twinhealthModal: false,
        });
    };

    setConsentGiven = (consentGiven: boolean) => {
        this.setState({
            consentGiven,
        });
    };

    closeShowedInterestStrip = () => {
        localStorage.setItem(HXNG_SHOWED_INTEREST_STRIP_SHOWN, 'true');
        this.setState({
            hideShowedInterestStrip: true,
        });
        track('HIDE_SHOWED_INTEREST_STRIP');
    };

    notesRef: TextAreaRef | null = null;

    conciergeCheckboxToggler = (e: CheckboxChangeEvent) => {
        e.stopPropagation();
        this.setState({
            isConciergeChecked: e.target.checked,
        });
    };

    conciergeDiscountToggler = (e: RadioChangeEvent) => {
        e.stopPropagation();
        this.setState({
            conciergeDiscount: e.target.value,
            isConciergeChecked: true,
        });
    };

    onPrintLocally = () => {
        this.setState({ isLocalPdfView: true }, () => {
            // timeout to give component time to render
            setTimeout(() => {
                const rxRenderPdfDiv = document.getElementById('rx-render-pdf');
                if (rxRenderPdfDiv) {
                    const iframe = rxRenderPdfDiv.querySelector('iframe');
                    if (iframe?.contentWindow) {
                        iframe.contentWindow.focus();
                        iframe.contentWindow.print();
                    } else {
                        alert('PDF is not yet ready for printing.');
                    }
                } else {
                    alert('Could not find PDF container to print.');
                    track('Unable to find PDF container for printing');
                    track('ERROR', {
                        on: 'triggeringLocalPrint',
                        what: 'Unable to find PDF container for printing',
                        prescriptionId: this.props.prescription?.id,
                        prescriptionData: JSON.stringify(this.props.prescription),
                        printConfigs: JSON.stringify(this.props.printConfigs),
                        medElements: JSON.stringify(this.props.medElements),
                        padElementsConfig: JSON.stringify(this.props.padElementsConfig),
                        sectionNameConfig: JSON.stringify(this.props.sectionNameConfig),
                    });
                }
            }, 500);
        });
    };

    render(): ReactNode {
        const {
            prescription,
            printConfigs,
            phDialogVisisble,
            translate,
            medElements,
            padElementsConfig,
            twinHealthEnabled,
            messageConfig,
            sectionNameConfig,
        } = this.props;
        const { pushStatus } = this.state;

        if (!prescription || !printConfigs) {
            return null;
        }

        const clinicPin = prescription.clinic.address?.pin || '';
        const pincode = (prescription.patient?.formData?.find((i) => i.key === 'pincode')?.value ||
            clinicPin ||
            '') as string;

        const {
            printUrl,
            isOrderMedicineDialogVisible,
            isBookLabTestDialogVisible,
            isPharmaChecked,
            isLabChecked,
            isRXMTChecked,
            isInitiatingRxMonetization,
            monetizeAmount,
            isFetchingCartDetails,
            force,
            twinHealth,
            twinhealthModal,
            twinHealthNotes,
            pharmaResponse,
            labResponse,
            consentGiven,
            hideShowedInterestStrip,
            isConciergeChecked,
            conciergeDiscount,
            ignoredraft,
            isLocalPdfView,
            localPdfPrintEnabled,
            isSettingsLoaded,
        } = this.state;
        const { rxMonetizationCheckboxToggler, initiatingRxMonetization } = this;
        const ageObj = prescription.patient.profile.personal.age || {};

        const age = getAgeInYears(ageObj) || 18;
        const delayed_rx_message = messageConfig?.find(
            (conf) => conf.id === MESSAGE_CONFIG_ID.RX_DELAYED_WHATSAPP_MESSAGE,
        )?.status;

        const { medications = [], labTests = [] } = prescription;
        const isOrderMedicineBtVisible = isOnboardedForPharma() && medications.length !== 0;
        const isBookLabTestBtVisible = isOnboardedForLab() && labTests.length !== 0;

        const isRXMTBtVisible =
            getRXMonetisationType() && (medications.length !== 0 || labTests.length !== 0);
        const isRXMT2BtVisible =
            isRXMonetisationT2() && (medications.length !== 0 || labTests.length !== 0);
        const isConciergeBtVisible = isOnboardedForLab() && labTests.length !== 0;

        return (
            <WithKeyboardPressHandling onKeyDown={this.onPrint} keyName="command+p,ctrl+p">
                <Modal
                    title="Notes for TwinHealth"
                    visible={twinhealthModal}
                    onOk={this.onOkTwinHealthNotes}
                    onCancel={this.onCancelTwinHealthNotes}
                    destroyOnClose
                >
                    <TextArea
                        autoFocus
                        defaultValue={twinHealthNotes}
                        ref={(ref) => (this.notesRef = ref)}
                    />
                </Modal>
                <div className="overflow-hidden bg-white pad-selected-shadow w-full h-full">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>
                            {prescription.patient.profile.personal.name.trim()}-Prescription-
                            {prescription.date.toDateString()}-
                            {prescription.date.getTime().toString().slice(-5)}
                        </title>
                    </Helmet>
                    <AnimatePresence>
                        {isOrderMedicineDialogVisible && (
                            <OrderMedicineDialog
                                closeMe={this.hideOrderMedicineDialogVisible}
                                formData={prescription.patient.formData || []}
                                pxid={prescription.id}
                                patientId={prescription.patient.id || ''}
                                name={prescription.patient.profile.personal.name}
                                phone={prescription.patient.profile.personal.phone?.n || ''}
                                gender={prescription.patient.profile.personal.gender}
                                age={age}
                                clinicPin={prescription.clinic.address?.pin || ''}
                            />
                        )}
                        {isBookLabTestDialogVisible && (
                            <BookLabTestsDialog
                                closeMe={this.hideBookLabTestDialogVisible}
                                formData={prescription.patient.formData || []}
                                pxid={prescription.id}
                                patientid={prescription.patient.id || ''}
                                name={prescription.patient.profile.personal.name}
                                phone={prescription.patient.profile.personal.phone?.n || ''}
                                gender={prescription.patient.profile.personal.gender}
                                age={age}
                            />
                        )}
                    </AnimatePresence>
                    {phDialogVisisble && <SendCommunicationDialog />}
                    <div className="flex flex-col h-full">
                        <div className="flex flex-col flex-auto overflow-hidden bg-neutral-9 h-full">
                            <div className="flex w-full h-full space-x-24 overflow-hidden">
                                <div className="flex flex-col p-16 w-40p justify-between overflow-auto h-full">
                                    <div className="">
                                        {printConfigs && (
                                            <PushData
                                                onPrint={
                                                    localPdfPrintEnabled && isSettingsLoaded
                                                        ? this.onPrintLocally
                                                        : this.onPrint
                                                }
                                                onDownload={this.onDownload}
                                                prescription={prescription}
                                                printConfig={printConfigs}
                                                translate={translate}
                                                pushStatus={pushStatus}
                                                setPushState={this.setPushStatus}
                                                delayed_rx_message={delayed_rx_message}
                                                setForce={this.setForce}
                                                setIgnoreDraft={this.setIgnoreDraft}
                                                isForce={force}
                                                isIgnoreDraft={ignoredraft}
                                                medElements={medElements}
                                                padElementsConfig={padElementsConfig}
                                                sectionNameConfig={sectionNameConfig}
                                                isFetchingCartDetails={isFetchingCartDetails}
                                                pharmaResponse={pharmaResponse}
                                                labResponse={labResponse}
                                                pincode={pincode}
                                                consentGiven={consentGiven}
                                                setConsentGiven={this.setConsentGiven}
                                            />
                                        )}
                                    </div>
                                    <div className="">
                                        <CreateTemplateDialog
                                            isModal={false}
                                            withPeak={false}
                                            kind={ALL_KINDS['PX']}
                                            onCancel={this.hideCreateTemplateDialog}
                                            onSave={this.onSaveAsTemplate}
                                            isCancelActive={false}
                                        />
                                    </div>
                                </div>
                                <div
                                    // style={{ zoom: isPrinting ? 1.2 : 0.8 }}
                                    className={
                                        localPdfPrintEnabled && isSettingsLoaded
                                            ? 'flex flex-col w-60p bg-white relative'
                                            : 'flex flex-col w-60p overflow-auto bg-white relative'
                                    }
                                >
                                    {printConfigs &&
                                        isSettingsLoaded &&
                                        (localPdfPrintEnabled ? (
                                            <CreateLocalPrintPdf
                                                prescription={prescription}
                                                printConfig={printConfigs}
                                                translate={translate}
                                                medElements={medElements}
                                                padElementsConfig={padElementsConfig}
                                                sectionNameConfig={sectionNameConfig}
                                                force={force}
                                                enableFixPdfIcon
                                            />
                                        ) : (
                                            <PrescriptionPDF
                                                elemId={DUMMY_PRINT_PDF_IFRAME}
                                                prescription={prescription}
                                                printConfig={printConfigs}
                                                setPrintUrl={this.setPrintUrl}
                                                translate={translate}
                                                onDummyIframeLoad={this.enablePrint}
                                                padElementsConfig={padElementsConfig}
                                                sectionNameConfig={sectionNameConfig}
                                                medElements={medElements}
                                                force={force}
                                                enableFixPdfIcon
                                            />
                                        ))}
                                    {/* {printConfigs && (
                                        <div style={{ visibility: 'hidden' }}>
                                            <PrescriptionPDF
                                                elemId={DUMMY_PRINT_PDF_IFRAME}
                                                prescription={prescription}
                                                printConfig={printConfigs}
                                                setPrintUrl={this.setPrintUrl}
                                                translate={translate}
                                                onDummyIframeLoad={this.enablePrint}
                                                padElementsConfig={padElementsConfig}
                                                sectionNameConfig={sectionNameConfig}
                                                medElements={medElements}
                                                force={force}
                                                enableFixPdfIcon
                                            />
                                        </div>
                                    )} */}
                                </div>
                            </div>
                        </div>
                        <div className="w-full border-b border-neutral-7"></div>

                        <div
                            className={`flex justify-between bg-white ${
                                delayed_rx_message ? ' px-16 pb-8' : 'p-16'
                            }`}
                            style={{ minHeight: 70 }}
                        >
                            <div className="space-x-16"></div>
                            <div
                                className={`flex  space-x-16 ${
                                    delayed_rx_message ? 'items-end' : 'items-center'
                                }`}
                            >
                                {/* {isConciergeBtVisible && (
                                    <div
                                        style={{
                                            visibility:
                                                pushStatus === 'loading' ? 'hidden' : 'visible',
                                        }}
                                    >
                                        <ConciergeButton
                                            isConciergeChecked={isConciergeChecked}
                                            conciergeDiscount={conciergeDiscount}
                                            conciergeCheckboxToggler={this.conciergeCheckboxToggler}
                                            conciergeDiscountToggler={this.conciergeDiscountToggler}
                                        />
                                    </div>
                                )} */}
                                {twinHealthEnabled && (
                                    <span
                                        // onClick={this.toggleTwinhealth}
                                        className="secondary-btn px-12 py-2 btn--small flex"
                                        style={{
                                            visibility:
                                                localPdfPrintEnabled && isSettingsLoaded
                                                    ? printConfigs && 'visible'
                                                    : !printUrl
                                                    ? 'hidden'
                                                    : 'visible',
                                        }}
                                    >
                                        <Checkbox
                                            onChange={this.onTwinHealthChange}
                                            className="flex items-center"
                                            checked={twinHealth}
                                        >
                                            <span className="flex space-x-8">
                                                <img
                                                    className="w-20 h-20"
                                                    src="/images/twinhealth.jpg"
                                                />
                                                <span>Enable Twin Health</span>
                                            </span>
                                        </Checkbox>
                                        <Button type="link" onClick={this.twinHealthNotes}>
                                            <svg
                                                className="fill-actionPrimary"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 13 13"
                                            >
                                                <path d="M12.0752 1.83594L11.1846 0.945312C10.9033 0.664062 10.5049 0.5 10.1299 0.5C9.75488 0.5 9.35645 0.664062 9.0752 0.945312L1.24707 8.77344C1.17676 8.82031 1.15332 8.89062 1.12988 8.96094L0.520508 12.0312C0.473633 12.2891 0.661133 12.5 0.87207 12.5C0.895508 12.5 0.942383 12.5 0.96582 12.5L4.03613 11.8906C4.10645 11.8672 4.17676 11.8438 4.24707 11.7734L12.0752 3.94531C12.6611 3.35938 12.6611 2.42188 12.0752 1.83594ZM3.59082 10.8359L1.83301 11.1875L2.18457 9.42969L2.77051 8.84375V10.25H4.17676L3.59082 10.8359ZM3.89551 9.125V7.71875L8.02051 3.59375L9.4502 5L5.30176 9.125H3.89551Z"></path>
                                            </svg>
                                        </Button>
                                    </span>
                                )}
                                {isRXMTBtVisible && (
                                    <div
                                        style={{
                                            visibility:
                                                pushStatus === 'loading' ? 'hidden' : 'visible',
                                        }}
                                    >
                                        <MonetizeRxButton
                                            type={getRXMonetisationType() as HxngMonetisation}
                                            prescription={prescription}
                                            isPharmaChecked={isPharmaChecked}
                                            isLabChecked={isLabChecked}
                                            isRXMTChecked={isRXMTChecked}
                                            rxMonetizationCheckboxToggler={
                                                rxMonetizationCheckboxToggler
                                            }
                                            initiatingRxMonetization={initiatingRxMonetization}
                                            isInitiatingRxMonetization={isInitiatingRxMonetization}
                                            monetizeAmount={monetizeAmount}
                                            isFetchingCartDetails={isFetchingCartDetails}
                                        />
                                    </div>
                                )}
                                <EditPrescriptionBt />
                                {isOrderMedicineBtVisible && (
                                    <div
                                        style={{
                                            visibility:
                                                pushStatus === 'loading' ? 'hidden' : 'visible',
                                        }}
                                    >
                                        <OrderMedicineBt
                                            onClick={this.showOrderMedicineDialogVisible}
                                        />
                                    </div>
                                )}
                                {isBookLabTestBtVisible && (
                                    <div
                                        style={{
                                            visibility:
                                                pushStatus === 'loading' ? 'hidden' : 'visible',
                                        }}
                                    >
                                        <BookLabTestBt
                                            onClick={this.showBookLabTestDialogVisible}
                                        />
                                    </div>
                                )}
                                <div
                                    style={{
                                        visibility:
                                            localPdfPrintEnabled && isSettingsLoaded
                                                ? printConfigs && 'visible'
                                                : !printUrl
                                                ? 'hidden'
                                                : 'visible',
                                    }}
                                >
                                    <button
                                        onClick={
                                            localPdfPrintEnabled && isSettingsLoaded
                                                ? () => {
                                                      this.onPrintLocally();
                                                      track('PRINT_LOCALLY', { from: 'bottom' });
                                                  }
                                                : () => {
                                                      this.onPrint();
                                                      track('PRINT', { from: 'bottom' });
                                                  }
                                        }
                                        className="flex px-12 py-6 secondary-btn btn--small cursor-pointer items-center"
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 28 28"
                                            className="fill-actionPrimary"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <path d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"></path>
                                        </svg>
                                        <span className="w-full text-center">
                                            {localPdfPrintEnabled && isSettingsLoaded
                                                ? 'Print'
                                                : 'Print'}
                                        </span>
                                    </button>
                                </div>
                                <div
                                    style={{
                                        visibility: pushStatus === 'loading' ? 'hidden' : 'visible',
                                    }}
                                >
                                    <GoToQueueButton
                                        twinHealth={twinHealth}
                                        twinHealthNotes={twinHealthNotes}
                                        prescription={prescription}
                                        isSendRxMessage={delayed_rx_message}
                                        initiatingRxMonetization={
                                            isRXMTChecked && isRXMT2BtVisible
                                                ? initiatingRxMonetization
                                                : undefined
                                        }
                                        isRXMT={Boolean(isRXMTChecked)}
                                        isConciergeSaved={
                                            isConciergeBtVisible && isConciergeChecked
                                        }
                                        conciergeDiscount={conciergeDiscount}
                                        totalLabTests={labTests.length}
                                    />
                                    {consentGiven &&
                                        !hideShowedInterestStrip &&
                                        (medications.length > 0 || labTests.length > 0) && (
                                            <div className="absolute bottom-64 right-16">
                                                <div
                                                    className="p-16 flex items-start rounded-8 bg-white"
                                                    style={{ border: '1px solid #FF6208' }}
                                                >
                                                    <div className="pt-2">
                                                        <svg
                                                            className="w-36 h-36"
                                                            viewBox="0 0 36 36"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <rect
                                                                width="36"
                                                                height="36"
                                                                rx="18"
                                                                fill="#E8F6F0"
                                                            />
                                                            <path
                                                                d="M18 30C13.6875 30 9.75 27.75 7.59375 24C5.4375 20.2969 5.4375 15.75 7.59375 12C9.75 8.29688 13.6875 6 18 6C22.2656 6 26.2031 8.29688 28.3594 12C30.5156 15.75 30.5156 20.2969 28.3594 24C26.2031 27.75 22.2656 30 18 30ZM23.2969 15.7969H23.25C23.7188 15.375 23.7188 14.6719 23.25 14.2031C22.8281 13.7812 22.125 13.7812 21.7031 14.2031L16.5 19.4531L14.2969 17.25C13.8281 16.7812 13.125 16.7812 12.7031 17.25C12.2344 17.6719 12.2344 18.375 12.7031 18.7969L15.7031 21.7969C16.125 22.2656 16.8281 22.2656 17.2969 21.7969L23.2969 15.7969Z"
                                                                fill="#19A66A"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div className="space-y-4 ml-16 mr-6">
                                                        <p className="text-13 font-700">
                                                            Place order for your patient and give a{' '}
                                                            <span style={{ color: '#FF6208' }}>
                                                                delightful care experience!
                                                            </span>
                                                        </p>
                                                        <p>
                                                            Click below to view cart and place the
                                                            order!
                                                        </p>
                                                    </div>
                                                    <AntTooltip
                                                        content="Don't show again"
                                                        placement="left"
                                                    >
                                                        <div
                                                            className="relative -top-8 -right-8 cursor-pointer"
                                                            onClick={this.closeShowedInterestStrip}
                                                        >
                                                            <svg
                                                                className="w-20 h-18 fill-darwin-neutral_new-800"
                                                                viewBox="0 0 18 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM6.46875 5.46875C6.15625 5.78125 6.15625 6.25 6.46875 6.53125L7.9375 8L6.46875 9.46875C6.15625 9.78125 6.15625 10.25 6.46875 10.5312C6.75 10.8438 7.21875 10.8438 7.5 10.5312L8.96875 9.0625L10.4375 10.5312C10.75 10.8438 11.2188 10.8438 11.5 10.5312C11.8125 10.25 11.8125 9.78125 11.5 9.46875L10.0312 8L11.5 6.53125C11.8125 6.25 11.8125 5.78125 11.5 5.46875C11.2188 5.1875 10.75 5.1875 10.4375 5.46875L8.96875 6.9375L7.5 5.46875C7.21875 5.1875 6.75 5.1875 6.46875 5.46875Z" />
                                                            </svg>
                                                        </div>
                                                    </AntTooltip>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WithKeyboardPressHandling>
        );
    }
}

export default connect((state: GlobalState) => ({
    prescription: getPrescription(state),
    phDialogVisisble: isPhDialogVisible(state),
    translate: getTranslate(state),
    printConfigs: getPrintConfigs(state),
    twinHealthEnabled: getGenieSetting(state, 'twinHealthEnabled') as boolean,
    medElements: getGenieSetting(
        state as GlobalStateV1,
        'medElements',
    ) as GeniePadElementsSettingItem[],
    padElementsConfig: getPxElementConfig(state),
    messageConfig: getGenieSetting(state, 'messageConfig') as MessageConfigType[],
    inventory: getInventory(state),
    hideNewHxngFlow: getGenieSetting(state, 'hideNewHxngFlow') as boolean,
    sectionNameConfig: getSectionNameConfig(state),
    isHxngPatientConsent: getGenieSetting(state, 'isHxngPatientConsent') as boolean,
}))(FinishedPanel);

export const triggerPushVisit = async (
    prescription: Prescription,
    printConfig?: PrintConfig,
    translate?: Translate,
    setPushState?: (status: PushStatus) => void,
    setWpString?: React.Dispatch<React.SetStateAction<string>>,
    setCanPay?: React.Dispatch<React.SetStateAction<boolean>>,
    onSuccess?: (e?: Error) => void,
    onSetCommunication?: (status?: COMMUNICATION) => void,
    send_rx_message?: boolean,
    onSetAttachmentState?: (
        attachmentState: 'no-attachment' | 'sending' | 'sent' | 'failed',
    ) => void,
    force: boolean = false,
    monetisation_type?: MONETISATION_TYPE | '',
    medElements?: GeniePadElementsSettingItem[],
    padElementsConfig?: GeniePadElementsSettingItem[],
    sectionNameConfig?: SectionNameConfig,
    setConsentGiven?: (consentGiven: boolean) => void,
    ignoredraft?: boolean,
    draftid?: string,
): Promise<void> => {
    const v = await getVisitById(prescription.visitId);
    if (!v) {
        track('ERROR', {
            on: 'triggerPushVisit',
            what: 'visit not found',
            visitId: prescription.visitId,
        });
        captureError(new Error('Visit not found' + prescription.visitId));
        return;
    }

    const templates = getTemplates();
    const template_v2 = {
        render_pdf_config: await getTemplateV2(
            prescription.doctor._id,
            prescription.clinic._id,
            'SEND',
        ),
        render_pdf_body_config: {
            medication_config: medElements,
            pad_elements_config: padElementsConfig,
            section_name_config: sectionNameConfig,
        },
    } as TemplateV2;

    const template_print_v2 = {
        render_pdf_config: await getTemplateV2(
            prescription.doctor._id,
            prescription.clinic._id,
            'PRINT',
        ),
        render_pdf_body_config: {
            medication_config: medElements,
            pad_elements_config: padElementsConfig,
            section_name_config: sectionNameConfig,
        },
    } as TemplateV2;

    try {
        track('TEMPLATE_V2_TRACKING', {
            precriptionId: prescription?.id,
            clinicId: prescription?.clinic?._id,
            printConfig: JSON.stringify(template_print_v2),
            sendConfig: JSON.stringify(template_v2),
        });
    } catch (error) {
        console.error('TEMPLATE_V2_TRACKING error', error);
    }

    let pc = printConfig;

    if (!pc) {
        pc = await getPrintConfig(getMyDbId() || '');
    }
    let t = translate;
    if (!t) {
        t = await getItemFromMisc<Translate>(getMyDbId() || '', MISC_KEYS.translate);
    }

    // TODO consolidated with past visit (resync flow)
    return pushVisitWithSanitizePrescription(
        prescription,
        v.startedAt || new Date(),
        v.endedAt || new Date(),
        'send',
        pc,
        t,
        templates?.send?.templateId,
        template_v2,
        send_rx_message,
        force,
        monetisation_type,
        ignoredraft,
        draftid,
        false,
        template_print_v2,
    )
        .then(async (response) => {
            setPushState && setPushState(response.status === 'success' ? 'success' : 'error');
            response.wpString && setWpString && setWpString(response.wpString);
            setCanPay && setCanPay(response.canPay || false);
            onSetCommunication && onSetCommunication(response?.communication);
            setConsentGiven && setConsentGiven(response?.consentGiven);
            onSetAttachmentState &&
                onSetAttachmentState(response?.attachmentSend === true ? 'sent' : 'failed');
            await updatePrescriptionUrlAndVisitNameInVisit(
                v.id,
                response.visitName ||
                    generateVisitName(new Date(v.createdAt).toString(), prescription),
                response.url,
            );

            if (response.pid) {
                const pt = await getPatientByLocalId(v.patient.localId);

                if (!pt) {
                    console.error('WTF, no pt with localId found');
                    track('ERROR', {
                        on: 'triggerPushVisit',
                        what: 'local pt not found on pushVisit',
                    });
                    onSuccess && onSuccess(new Error('Something went wrong.'));
                } else {
                    try {
                        // remove zoombie pt => update pid
                        await deletePatientByLocalId(pt.localId);

                        await upsertPatient({ ...pt, localId: response.pid, id: response.pid });

                        // update pt references in the visits
                        await updatePtInVisit(v.id, {
                            ...v.patient,
                            localId: response.pid,
                            id: response.pid,
                        });

                        // update pt refrerence in the  px
                        await updatePtInPx(prescription.id, {
                            ...prescription.patient,
                            localId: response.pid,
                            id: response.pid,
                        });
                        if (!prescription.patient.id) {
                            store.dispatch(
                                updatePatient({
                                    ...prescription.patient,
                                    localId: response.pid,
                                    id: response.pid,
                                }),
                            );
                        }

                        onSuccess && onSuccess();
                    } catch (e) {
                        track('ERROR', {
                            on: 'triggerPushVisit',
                            what: 'error on local update on pushVisit',
                            error: (e as Error).message,
                        });
                        onSuccess && onSuccess(new Error('Something went wrong.'));
                    }
                }

                if (response.status !== 'success') {
                    await markPrescriptionAsPushFailedStatus(prescription.id, 1);
                } else {
                    await markPrescriptionAsPushFailedStatus(prescription.id, 0);
                }
            } else {
                track('ERROR', { on: 'triggerPushVisit', what: 'pid not found on pushVisit' });
                onSuccess && onSuccess(new Error('Something went wrong.'));
            }
        })
        .catch(async (e) => {
            if (e.message === ALREADY_SAVED || e.message === LATEST_DRAFT_NOT_APPLIED) {
                throw e;
            }

            console.error('pushData=>', e);
            captureError(e);
            setPushState && setPushState('offline');

            await markPrescriptionAsPushFailedStatus(prescription.id, 1);

            track('ERROR', {
                on: 'triggerPushVisit',
                what: 'failed to pushVisit',
                error: (e as Error).message,
                prescriptionId: prescription.id,
                visitId: v.id,
            });
            onSuccess && onSuccess(new Error('Something went wrong.'));

            updatePrescriptionUrlAndVisitNameInVisit(
                v.id,
                generateVisitName(new Date(v.createdAt).toString(), prescription),
            );
        });
};

export const pushVisitWithSanitizePrescription = (
    visitData: Prescription,
    startedAt: Date,
    endedAt: Date,
    context: 'send' | 'print',
    printConfig: PrintConfig,
    translate: Translate,
    templateId?: string,
    template_v2?: TemplateV2,
    send_rx_message?: boolean,
    force?: boolean,
    monetisation_type?: MONETISATION_TYPE | '',
    ignoredraft?: boolean,
    draftid?: string,
    isFromCreateLocalPdf?: boolean,
    template_print_v2?: TemplateV2,
): Promise<Response> => {
    const sanitizedPrescription = sanitizeFinalPrescriptionFunction(visitData);
    store.dispatch(sanitizeFinalPrescription(sanitizedPrescription));
    return pushVisit(
        sanitizedPrescription,
        startedAt,
        endedAt,
        context,
        printConfig,
        translate,
        templateId,
        template_v2,
        send_rx_message,
        force,
        monetisation_type,
        ignoredraft,
        draftid,
        isFromCreateLocalPdf,
        template_print_v2,
    );
};
